import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers';


@Injectable()
export class CtnNumberService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService) { }

  getCtnNumbers(ctnNumberUrl) {
    return this.httpClientService.get(ctnNumberUrl)
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  handleError(error) {
    return throwError(error);
  }
}
